import React from 'react';

const SocialBar = () => {
	return 	<div id="social-bar">
				<div className="container">
					<div className="row">
						<div className="col-sm-12">
							<ul className="nav nav-justified" prefix="s: http://schema.org" typeof="s:LinkListTms">
								<li>
									<a href="https://twitter.com/CanonMedical" target="_blank" rel="noopener noreferrer" title="Visit us on Twitter">
										<i className="zmdi zmdi-twitter-box"></i>
										Twitter
									</a>
								</li>
								<li>
									<a href="https://www.facebook.com/CanonMedical" target="_blank" rel="noopener noreferrer" title="Visit us on Facebook">
										<i className="zmdi zmdi-facebook-box"></i>
										Facebook
									</a>
								</li>
								<li>
									<a href="https://www.linkedin.com/company-beta/16230657/" target="_blank" rel="noopener noreferrer" title="Visit us on LinkedIn">
										<i className="zmdi zmdi-linkedin-box"></i>
										LinkedIn
									</a>
								</li>
								<li>
									<a href="https://www.youtube.com/channel/UCIhADTRbjgRGZyMMXHPp_uw" target="_blank" rel="noopener noreferrer" title="Visit us on YouTube">
										<i className="zmdi zmdi-youtube-play"></i>
										YouTube
									</a>
								</li>
								<li>
									<a href="https://plus.google.com/u/4/106721522686681120196" target="_blank" rel="noopener noreferrer" title="Visit us on Google+">
										<i className="zmdi zmdi-google-plus-box"></i>
										Google+
									</a>
								</li>
								<li id="share-dropdown-footer" className="dropdown">
									<a href="https://global.medical.canon/#" className="dropdown-toggle" data-toggle="dropdown" title="Share"><i className="zmdi zmdi-share"></i> Share </a>
									<ul className="dropdown-menu dropdown-up dropdown-left">
										<li>
											<a href="https://twitter.com/CanonMedical"><i className="zmdi zmdi-twitter-box"></i> Twitter</a>
										</li>
										<li>
											<a href="https://www.facebook.com/CanonMedical"><i className="zmdi zmdi-facebook-box"></i> Facebook</a>
										</li>
										<li>
											<a href="https://www.linkedin.com/company-beta/16230657/"><i className="zmdi zmdi-linkedin-box"></i> LinkedIn</a>
										</li>
										<li>
											<a href="https://www.gmail.com/"><i className="zmdi zmdi-email"></i> Email</a>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
}

export default SocialBar;


// WEBPACK FOOTER //
// ./src/blocks/socialbar/socialbar.jsx